/** CSS easing for dashboard enters (sections, shimmer). */
export const DASHBOARD_EASE_OUT_CSS = 'cubic-bezier(0.22, 1, 0.36, 1)';

/** Recharts named easing closest to ease-out. */
export const DASHBOARD_RECHARTS_EASE = 'ease-out' as const;

export const DASHBOARD_MOTION = {
  shimmerCycleMs: 1200,
  sectionEnterMs: 240,
  sectionEnterReducedMs: 120,
  sectionStaggerMs: 50,
  figureCountUpMs: 650,
  sparklineDrawMs: 700,
  scoreBandMs: 600,
  scoreMedianMs: 700,
  scoreMedianBeginMs: 600,
  helpfulnessBarsMs: 600,
  voteRateLineMs: 700,
  chartVisibleThreshold: 0.25,
} as const;

/** Cubic ease-out for figure count-up (matches CSS curve shape). */
export function easeOutCubic(t: number): number {
  const clamped = Math.min(1, Math.max(0, t));
  return 1 - (1 - clamped) ** 3;
}
